import { useState } from 'react';
import { useIntroducerData } from 'contexts/IntroducerData/IntroducerData.context';
import { DeactivateUserModal } from '../DeactivateUserModal/DeactivateUserModal';
import { EditUserModal } from '../EditUserModal/EditUserModal';
import { ReactivateUserModal } from '../ReactivateUserModal/ReactivateUserModal';
import { TIntroducerListItem } from '../UsersTable.types';
import { RowActionsMenu, TRowAction } from './RowActionsMenu';

type TProps = {
  user: TIntroducerListItem;
};

type TOpenModal = TRowAction | null;

export const ActionsCell = ({ user }: TProps) => {
  const { introducer } = useIntroducerData();
  const [openModal, setOpenModal] = useState<TOpenModal>(null);

  // Gate on the introducer resolving so isSelf is definitive before the modal
  // mounts — otherwise a master broker editing their own row could land on the
  // unguarded form for one render and self-revoke `Manage users`.
  if (!introducer) return null;

  const isSelf = introducer.id === user.id;
  const closeModal = () => setOpenModal(null);

  return (
    <>
      <RowActionsMenu
        isActive={user.is_active}
        isSelf={isSelf}
        onAction={setOpenModal}
      />
      {openModal === 'edit' && (
        <EditUserModal
          user={user}
          isSelf={isSelf}
          isOpen
          onClose={closeModal}
        />
      )}
      {openModal === 'deactivate' && (
        <DeactivateUserModal user={user} isOpen onClose={closeModal} />
      )}
      {openModal === 'reactivate' && (
        <ReactivateUserModal user={user} isOpen onClose={closeModal} />
      )}
    </>
  );
};
